import React from "react";
import TransactionTable from "./list/TransactionList";
import "../../components/common/css/datatable.scss";
import "../../components/common/css/index.scss";

const Transaction = () => {
  return (
    <div className="list">
      <div className="listContainer">
        <TransactionTable />
      </div>
    </div>
  );
};

export default Transaction;
